import axios from 'axios';

declare global {
  interface Window {
    chrome?: any;
  }
}

export const openOFDTab = async () => {
  try {
    // Получаем логин текущего пользователя из localStorage
    const username = localStorage.getItem('username');
    
    if (!username) {
      console.error('Пользователь не авторизован');
      return;
    }

    // Запрашиваем данные ОФД для пользователя из БД
    const response = await axios.get(`https://tbl.zerdegroup.kz/api/ofd/user/${username}`);

    if (!response.data.success) {
      console.error('Данные ОФД не найдены для пользователя:', username);
      alert('Данные ОФД не настроены для вашего аккаунта. Обратитесь в IT отдел.');
      return;
    }

    const { ofdLogin, ofdPassword, browserId } = response.data.data;

    // Отправка сообщения расширению для автологина и открытия новой вкладки
    if (typeof window.chrome !== 'undefined' && window.chrome?.runtime?.sendMessage) {
      window.chrome.runtime.sendMessage(
        browserId,
        {
          action: "login",
          data: {
            Login: ofdLogin,
            Password: ofdPassword
          }
        },
        (response: any) => {
          if (window.chrome?.runtime?.lastError) {
            console.error('Ошибка при отправке сообщения расширению:', window.chrome.runtime.lastError);
            alert('Не удалось открыть ОФД. Убедитесь, что расширение установлено.');
          } else {
            console.log('Сообщение успешно отправлено расширению');
          }
        }
      );
    } else {
      console.warn('Chrome extension API недоступен');
      alert('Расширение Chrome недоступно. Используйте браузер Chrome.');
    }
  } catch (error) {
    console.error('Ошибка при открытии ОФД:', error);
    alert('Произошла ошибка при открытии ОФД. Обратитесь к администратору.');
  }
};

